import {
  FormHelperText as MuiFormHelperText,
  type FormHelperTextProps as MuiFormHelperTextProps
} from '@mui/material';

export type FormHelperTextProps = MuiFormHelperTextProps;

export const FormHelperText = (props: Readonly<FormHelperTextProps>) => (
  <MuiFormHelperText {...props} />
);
